











import { Component, Vue, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';
import DataTable from '@/trials/views/components/DataTable.vue';

import KnowledgeChunks from '@/trials/domain/objects/knowledgeChunks';

@Component({ components: { DataTable } })
export default class KCList extends Vue {
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private kcList: any[] = [];
    private defaultSortBy: any = {};
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        this.setTableData();
    }

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    /*----------------------------------*
     * Watch
     *-----------------------------------*/
    @Watch('$i18n.locale')
    private changeLocale(newVal: string) {
        this.setTableData();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/

    private setTableData(): void {
        const listData = sessionModule.getKCListData;

        if (listData === null) {
            return;
        }

        const data = listData.weightNotZeroObjects;
        const showHeaders = [
            this.$i18n.t('trials.caption.results.knowledge_chunk.chunk'),
            this.$i18n.t('trials.caption.results.knowledge_chunk.len'),
            this.$i18n.t('trials.caption.results.knowledge_chunk.npos'),
            this.$i18n.t('trials.caption.results.knowledge_chunk.nneg'),
        ];

        const nposKey: any = this.$i18n.t('trials.caption.results.knowledge_chunk.npos');
        this.defaultSortBy[nposKey] = true;

        // 表示に必要なカラムのデータだけ抽出
        const kcList: any[] = data.map(obj => {
            return [obj.chunk, obj.len, obj.npos, obj.nneg];
        });

        // header追加
        kcList.unshift(showHeaders);

        this.kcList = kcList;
    }
}
